import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export default class HorizontalCarousel {
    constructor(el) {
        this.el = el;
        const scrollElement = this.el.querySelector('[data-horizontal-carousel-wrapper]');

        let tween = gsap.to(scrollElement, {
            x: () => {
                const totalWidth = scrollElement.scrollWidth - el.clientWidth;
                return -totalWidth;
            },
            ease: 'none',
        });

        ScrollTrigger.create({
            trigger: el,
            start: 'top',
            end: 'bottom bottom',
            animation: tween,
            scrub: true,
            invalidateOnRefresh: true,
        });
    }
}